export default __webpack_public_path__ + "static/media/locIcon.8d8978d0.svg";